export const CHALLENGES_COLLECTION = "job_challenges";
